import React from 'react'

function Tab({children, selected, onClick}) {
  function handleClick(e) {
    e.stopPropagation()
    onClick()
  }


  let cl = "tab" + (selected ? " selected" : "")
  return (
    <div className={cl} onClick={handleClick} dangerouslySetInnerHTML={{__html: children}}>

    </div>
  )
}

export default Tab
